/* eslint-disable no-use-before-define */
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as tagActions from '../../redux/actions/tagActions';
import { debounce } from 'throttle-debounce';
import { apiCallDebounceTime } from '../../Constants/Api';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 500,
		'& > * + *': {
			marginTop: theme.spacing(3),
		},
		'& .MuiInputBase-root': {
			height: 'auto',
		},
	},
}));
// Tags multi search component with Chip component render for selected tags.
const TagsMultiSearch = (props) => {
	const classes = useStyles();
	const options = useSelector((state) => state.tags.options);
	const optionsWithAssetTags = props.assetTags;
	const dispatch = useDispatch();
	const onInputChange = (event, value) => {
		if (value) {
			DebounceAssetTabTagsSearch(value);
		}
	};
	//implementing debounce for tags search.
	//only trigger API call when there is a delay of mentioned time from last keystroke
	const DebounceAssetTabTagsSearch = useCallback(
		debounce(apiCallDebounceTime, false, (value) => dispatch(tagActions.loadTagsSearchData(value)).then(() => {})),
		[],
	);
	const onChange = (event, options, reason, changedDetails) => {
		props.onValueChange(reason, changedDetails);
	};
	useEffect(() => {
		const close = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
		close.addEventListener('click', (event) => {
			// TODO: when user click on clear all Icon in autocomplete, Add a dialog before clearing all the tags.
			event.stopImmediatePropagation();
		});
		return () => {};
	}, []);
	return (
		<div className={classes.root}>
			<Autocomplete
				multiple
				id="add-tags"
				data-cy="add-tags"
				options={options.map((option) => {
					return option ?? '';
				})}
				value={optionsWithAssetTags}
				onInputChange={onInputChange}
				filterSelectedOptions
				onChange={onChange}
				freeSolo
				renderTags={(value, getTagProps) => {
					return value.map((option, index) => (
						<div data-cy={`delete-icon-${index}`}>
							<Chip
								variant="outlined"
								label={option}
								{...getTagProps({ index })}
								data-cy={`delete-icon-${index}`}
							/>
						</div>
					));
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						placeholder="Tags"
						InputProps={{
							...params.InputProps,
						}}
					/>
				)}
			/>
		</div>
	);
};

export default TagsMultiSearch;
